import React, { useState } from 'react';
import Viewport3D from '@/components/studio/Viewport3D';
import Topbar from '@/components/studio/Topbar';
import LeftRail from '@/components/studio/LeftRail';
import RightInspector from '@/components/studio/RightInspector';
import ExportDialog from '@/components/studio/ExportDialog';
import GalleryDrawer from '@/components/studio/GalleryDrawer';
import UpgradeDialog from '@/components/studio/UpgradeDialog';
import MobileControls from '@/components/studio/MobileControls';
import WelcomeDialog from '@/components/studio/WelcomeDialog';
import { useRef, useCallback } from 'react';

export default function Studio() {
  const [exportOpen, setExportOpen] = useState(false);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [upgradeOpen, setUpgradeOpen] = useState(false);
  const captureRef = useRef(null);
  const handleReady = useCallback((fn) => { captureRef.current = fn; }, []);
  const captureFn = useCallback(() => (captureRef.current ? captureRef.current() : null), []);

  return (
    <div className="h-screen w-screen overflow-hidden flex flex-col" data-testid="studio-root">
      <Topbar
        onExport={() => setExportOpen(true)}
        onOpenGallery={() => setGalleryOpen(true)}
        onOpenUpgrade={() => setUpgradeOpen(true)}
      />
      <div className="flex-1 flex overflow-hidden">
        <aside className="hidden lg:flex w-[260px] shrink-0 border-r border-slate-200 bg-white" data-testid="left-rail">
          <LeftRail />
        </aside>
        <main className="relative flex-1 studio-canvas grain">
          <Viewport3D onReady={handleReady} />
        </main>
        <aside className="hidden lg:flex w-[320px] shrink-0 border-l border-slate-200 bg-white" data-testid="right-inspector">
          <RightInspector />
        </aside>
      </div>
      <ExportDialog open={exportOpen} onOpenChange={setExportOpen} captureFn={captureFn} onNeedsUpgrade={() => { setExportOpen(false); setUpgradeOpen(true); }} />
      <GalleryDrawer open={galleryOpen} onOpenChange={setGalleryOpen} captureFn={captureFn} />
      <UpgradeDialog open={upgradeOpen} onOpenChange={setUpgradeOpen} />
      <MobileControls />
      <WelcomeDialog />
    </div>
  );
}
